import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { PROFILE_NAV_ITEMS } from "../profileNavigation";
import { fetchPremiumSocial } from "../../../api/premiumSocialService";

export default function ProfileMobileNav() {
  const [myTeam, setMyTeam] = useState(null);
  const [teamLoaded, setTeamLoaded] = useState(false);

  useEffect(() => {
    const controller = new AbortController();
    fetchPremiumSocial(controller.signal)
      .then((data) => {
        setMyTeam((data.teams || [])[0] || null);
        setTeamLoaded(true);
      })
      .catch(() => setTeamLoaded(true));
    return () => controller.abort();
  }, []);

  const activeClass =
    "rounded-full bg-[linear-gradient(135deg,#5fb56f,#2f9de2)] px-4 py-2 text-sm font-semibold text-white shadow-lg";
  const inactiveClass =
    "rounded-full border border-emerald-100 bg-white px-4 py-2 text-sm font-semibold text-slate-600 transition";

  return (
    <div className="-mx-4 overflow-x-auto px-4 xl:hidden">
      <div className="flex min-w-max gap-2">
        {PROFILE_NAV_ITEMS.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) => (isActive ? activeClass : inactiveClass)}
          >
            {item.shortLabel}
          </NavLink>
        ))}

        {/* Dynamic team item */}
        {teamLoaded && (
          myTeam ? (
            <NavLink
              to="/profile/team"
              className={({ isActive }) => (isActive ? activeClass : inactiveClass)}
            >
              Mon équipe
            </NavLink>
          ) : (
            <NavLink
              to="/profile/team"
              className={({ isActive }) => (isActive ? activeClass : inactiveClass)}
            >
              Créer équipe
            </NavLink>
          )
        )}
      </div>
    </div>
  );
}
